<template>
  <div class="absolute top-10 right-10 z-10">
    <slot name="close" />
  </div>
  <div class="w-full pt-24 md:pt-0 md:w-auto mb-6">
    <slot name="title" />
  </div>
</template>
